import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { createTicket, uploadImage } from '../api';
import { FormField, CustomButton, Loader } from '../components';
import { AuthContext } from '../Context/AuthContext';

const CreateTicket = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { token } = useContext(AuthContext); // Access user and token from context

  const [form, setForm] = useState({
    title: '',
    category: '',
    description: '',
    location_link: '',
    contact_number: '',
    image_url: '',
    visibility: 'public'
  });
  const [file, setFile] = useState(null); // For image upload
  const navigate = useNavigate();

  const handleFormFieldChange = (fieldName, e) => {
    setForm({ ...form, [fieldName]: e.target.value });
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Validate location link format
    const googleMapsRegex = /^https:\/\/maps\.app\.goo\.gl\/.+$/;
    if (form.location_link && !googleMapsRegex.test(form.location_link)) {
      alert('Invalid location link. Please use a valid Google Maps URL.');
      setIsLoading(false);
      return;
    }

    try {
      // Upload image if a file is selected
      if (file) {
        const formData = new FormData();
        formData.append('file', file);
        const response = await uploadImage(token, formData);
        form.image_url = response.data.filename; // Save the filename
      }

      // Create ticket with or without image
      await createTicket(token, form);
      alert('Ticket created successfully');
      navigate('/');
    } catch (error) {
      alert(error.response?.data?.message || 'Failed to create ticket');
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="bg-[#1c1c24] flex justify-center items-center flex-col rounded-[10px] sm:p-10 p-4">
      {isLoading && <Loader />}

      <div className="flex justify-center items-center p-[4px] sm:min-w-[380px] bg-[#3a3a43] rounded-[10px]">
        <h1 className="font-bold text-lg leading-[38px] text-white">Create a Complaint to City Organizers</h1>
      </div>

      <form onSubmit={handleSubmit} className="w-full mt-[20px] flex flex-col gap-[30px]">
        <div className="flex flex-wrap gap-[40px]">
          <FormField
            labelName="Title*"
            placeholder="Write a title"
            inputType="text"
            value={form.title}
            required
            editable={true}
            handleChange={(e) => handleFormFieldChange('title', e)}
          />
          <FormField
            labelName="Category*"
            placeholder="Select a category"
            inputType="select"
            value={form.category}
            required
            editable={true}
            options={[
              'Streetlights',
              'Potholes',
              'Traffic Signals',
              'Waste Management',
              'Public Transport',
              'Water Supply',
              'Electricity',
              'Road Safety',
              'Noise Pollution',
              'Air Pollution'
            ]}
            handleChange={(e) => handleFormFieldChange('category', e)}
          />
        </div>

        <FormField
          labelName="Description (Min 100 Characters) *"
          placeholder="Write your complaint in detail"
          isTextArea
          value={form.description}
          required
          editable={true}
          handleChange={(e) => handleFormFieldChange('description', e)}
        />

        <FormField
          labelName="Location Link (Optional)"
          placeholder="Paste a valid Google Maps URL (e.g., https://maps.app.goo.gl/...)"
          inputType="url"
          value={form.location_link}
          editable={true}
          handleChange={(e) => handleFormFieldChange('location_link', e)}
        />

        <FormField
          labelName="Contact Number (Optional)"
          placeholder="Enter contact number"
          inputType="tel"
          value={form.contact_number}
          editable={true}
          handleChange={(e) => handleFormFieldChange('contact_number', e)}
        />

        <FormField
          labelName="Upload Image (Optional)"
          placeholder="Choose an image"
          inputType="file"
          handleChange={handleFileChange}
        />

        <FormField
          labelName="Visibility*"
          placeholder="Select visibility"
          inputType="radio"
          options={['public', 'private']}
          value={form.visibility}
          required
          editable={true}
          handleChange={(e) => handleFormFieldChange('visibility', e)}
        />

        <div className="flex justify-center items-center mt-[40px]">
          <CustomButton
            btnType="submit"
            title="Submit Ticket"
            styles="bg-[#1dc071]"
          />
        </div>
      </form>
    </div>
  );
};

export default CreateTicket;